import { Tag } from "primereact/tag";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IconLive } from "../../../../layout/components/Icons";
import { ANNOUNCEMENT_STATUSES } from "../../../constants";
import { Announcement } from "../../../models";
import { AnnouncementStatus } from "../../../types";

interface StatusTagBodyTemplateProps {
    rowData: Announcement;
}

const STATUS_CONFIG: Record<
    AnnouncementStatus,
    { className: string; icon: string | ReactNode }
> = {
    [ANNOUNCEMENT_STATUSES.LIVE]: {
        className: "bg-primary-default text-primary-text",
        icon: (
            <span className="mr-1 animate-pulse">
                <IconLive />
            </span>
        ),
    },
    [ANNOUNCEMENT_STATUSES.ACTIVE]: {
        className:
            "bg-transparent border border-success-default text-success-default",
        icon: "pi pi-check",
    },
    [ANNOUNCEMENT_STATUSES.DRAFT]: {
        className:
            "bg-transparent border border-info-default text-info-default",
        icon: "pi pi-pencil",
    },
    [ANNOUNCEMENT_STATUSES.ARCHIVED]: {
        className:
            "bg-transparent border border-default text-default opacity-60",
        icon: "pi pi-box",
    },
};

const StatusTagBodyTemplate = (props: StatusTagBodyTemplateProps) => {
    const { rowData } = props;
    const { t } = useTranslation("announcements");

    const { className, icon } = STATUS_CONFIG[rowData.status];

    return (
        <Tag
            rounded
            icon={icon}
            className={`${className} whitespace-nowrap`}
            value={t(`announcements:table.statusValues.${rowData.status}`)}
        />
    );
};

export default StatusTagBodyTemplate;
